import {useEffect, useContext, useRef} from 'react';
import {useFlagsStatus} from '@unleash/proxy-client-react';
import isEqual from 'lodash/isEqual';
import AppContext from '../../AppContext';
import CoupleContext from '../../CoupleContext';
import useOOSTopSort from '../../../hooks/useOOSTopSort';

const useShouldFetchItems = (
  sort,
  page,
  filters,
  previousSort,
  previousPage,
  previousFilters,
  refreshItemsSignal,
  fetchItems,
) => {
  const isFirstRender = useRef(true);
  const previousRefreshItemsSignal = useRef(refreshItemsSignal);
  const {flagsReady: isFlagsReady} = useFlagsStatus();
  const {hasVisitedManage, hasVisitedOverview} = useContext(AppContext);
  const {fetchingCouple} = useContext(CoupleContext);
  const {shouldTopSort, isLoading} = useOOSTopSort();

  useEffect(() => {
    if (fetchingCouple || isLoading || !isFlagsReady) return;

    const shouldFetchItems =
      !isEqual(sort, previousSort) ||
      !isEqual(page, previousPage) ||
      !isEqual(filters, previousFilters);
    const hasRefreshSignalChanged =
      refreshItemsSignal !== previousRefreshItemsSignal.current;
    previousRefreshItemsSignal.current = refreshItemsSignal;

    if (
      !isFirstRender.current &&
      (shouldFetchItems || hasRefreshSignalChanged)
    ) {
      fetchItems(shouldTopSort);
    }

    /**
     * On the initial load (first Manage or Overview visit), we should fetchItems.
     * Afterwards, listen for any filter, sort, or pagination changes.
     */
    const hasVisitedEligibleSurface =
      hasVisitedManage === 1 || hasVisitedOverview === 1;
    if (isFirstRender.current && hasVisitedEligibleSurface) {
      isFirstRender.current = false;
      fetchItems(shouldTopSort);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fetchingCouple,
    hasVisitedManage,
    hasVisitedOverview,
    shouldTopSort,
    isLoading,
    isFlagsReady,
    sort,
    page,
    filters.price,
    filters.type,
    filters.status,
    filters.stores,
    refreshItemsSignal,
  ]);
};

export default useShouldFetchItems;
